import { Injectable, inject } from '@angular/core'
import { CANADIAN_PROVINCES, locationLSKey } from '../constants/provinces'
import { LocationFromApi, LocationInLS } from '../types/locations'
import { LocationDialogComponent } from '../components/settings/location/location-dialog/location-dialog.component'
import { Dialog } from '@angular/cdk/dialog'
import { catchError, Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { ErrorService } from './error.service'
import { RecyclabilityLocation } from '../types/recyclability'
import { RECYCLABILITY_COUNTRIES } from '../constants/country-recyclability'

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'locations'

  /**
   * Adds user preferred Location to local storage
   * @param {LocationInLS} locationObj user selected Location
   */
  storeLocationInLS(locationObj: LocationInLS) {
    let stringifiedObj
    try {
      stringifiedObj = JSON.stringify(locationObj)
    } catch {
      // if there is an error, default to Canada & Alberta
      const now = new Date()
      stringifiedObj = JSON.stringify({
        country: RECYCLABILITY_COUNTRIES[0],
        province: CANADIAN_PROVINCES[0].name,
        expiry: now.getTime() + 7 * 24 * 60 * 60 * 1000,
      })
    }
    localStorage.setItem(locationLSKey, stringifiedObj)
    window.location.reload()
  }

  /**
   * Retrieves user location from local storage, if no location is found or is expired return null
   * @returns {LocationInLS | null} The location (if any)
   */
  getLocationFromLS(): LocationInLS | null {
    try {
      const storedLocationRaw = localStorage.getItem(locationLSKey)

      if (!storedLocationRaw) {
        return null
      }

      const location = JSON.parse(storedLocationRaw)

      const now = new Date().getTime()

      return now < location.expiry ? location : null
    } catch {
      return null
    }
  }

  /**
   * Retrieves users current location from the api
   * @returns {Observable<LocationFromApi>}
   */
  getLocationApi(): Observable<LocationFromApi> {
    return this.http
      .get<LocationFromApi>(`${this.URL}/me`)
      .pipe(catchError(this.errorService.handleError))
  }

  async showLocationDialog(dialog: Dialog): Promise<void> {
    dialog.open<string>(LocationDialogComponent, {
      width: '550px',
      height: 'fit-content',
      autoFocus: false,
      data: {},
    })
  }

  getLocation(): RecyclabilityLocation | null {
    const locationFromLS = this.getLocationFromLS()

    if (locationFromLS) {
      if (locationFromLS.country === 'Canada' && locationFromLS.province) {
        return locationFromLS.province
      }

      if (locationFromLS.country) {
        return locationFromLS.country
      }
    }

    return null
  }
}
